import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useInterviewContext } from "../InterviewContext";
import AutoComplete from "../../../components/AutoComplete/AutoComplete";
import PropTypes from "prop-types";
import icon_delete from "../../../layout/others/icon_delete.svg";
import "react-datetime/css/react-datetime.css";
import "../../styles/forms.scss";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";

const EducationForm = ({
  candidateCourse,
  index,
  onChangeCourse,
  onDelete,
  onSelectedCourse,
  onSelectedSchool,
  onChangeIsOngoing,
  onChangeIsCertification,
  onChangeFinalClassification
}) => {
  const { t } = useTranslation();
  const {
    autoCompleteCourseData,
    setInterview,
    autoCompleteSchoolData
  } = useInterviewContext();

  const today = new Date();
  const [isStartDateValid, setIsStartDateValid] = useState(true);
  const [isEndDateValid, setIsEndDateValid] = useState(true);

  const onChangeStartDate = (event) => {
    const { name, valueAsNumber } = event.target;

    if (candidateCourse.endDate === null) {
      if (valueAsNumber > today.getFullYear() || valueAsNumber < 1900) {
        setIsStartDateValid(false);
      } else {
        setIsStartDateValid(true);
      }
    } else {
      if (
        valueAsNumber > candidateCourse.endDate ||
        valueAsNumber > today.getFullYear() ||
        valueAsNumber < 1900
      ) {
        setIsStartDateValid(false);
      } else {
        setIsStartDateValid(true);
      }
    }

    if (isNaN(valueAsNumber)) {
      onChangeCourse({ target: { name: name, value: null } }, index);
    } else {
      onChangeCourse({ target: { name: name, value: valueAsNumber } }, index);
    }
  };

  const onChangeEndDate = (event) => {
    const { name, valueAsNumber } = event.target;

    if (valueAsNumber < candidateCourse.startDate || valueAsNumber < 1900) {
      setIsEndDateValid(false);
    } else {
      setIsEndDateValid(true);
    }

    if (isNaN(valueAsNumber)) {
      onChangeCourse({ target: { name: name, value: null } }, index);
    } else {
      onChangeCourse({ target: { name: name, value: valueAsNumber } }, index);
    }
  };

  const onChangeAutoCompleteCourse = (componentEvent, index) => {
    if (componentEvent.newValue === "") {
      setInterview((prevInterview) => ({
        ...prevInterview,
        interviewEducation: {
          ...prevInterview.interviewEducation,
          candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
            (course, courseIndex) =>
              courseIndex === index
                ? {
                    ...course,
                    courseId: null,
                    otherCourse: null,
                    courseDescription: null
                  }
                : { ...course }
          )
        }
      }));
    } else {
      setInterview((prevInterview) => ({
        ...prevInterview,
        interviewEducation: {
          ...prevInterview.interviewEducation,
          candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
            (course, courseIndex) =>
              courseIndex === index
                ? {
                    ...course,
                    courseId: null,
                    otherCourse: componentEvent.newValue
                  }
                : { ...course }
          )
        }
      }));
    }
  };

  const onChangeAutoCompleteSchool = (componentEvent, index) => {
    if (componentEvent.newValue === "") {
      setInterview((prevInterview) => ({
        ...prevInterview,
        interviewEducation: {
          ...prevInterview.interviewEducation,
          candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
            (course, courseIndex) =>
              courseIndex === index
                ? {
                    ...course,
                    schoolId: null,
                    otherSchool: null,
                    schoolDescription: null
                  }
                : { ...course }
          )
        }
      }));
    } else {
      setInterview((prevInterview) => ({
        ...prevInterview,
        interviewEducation: {
          ...prevInterview.interviewEducation,
          candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
            (course, courseIndex) =>
              courseIndex === index
                ? {
                    ...course,
                    schoolId: null,
                    otherSchool: componentEvent.newValue
                  }
                : { ...course }
          )
        }
      }));
    }
  };

  return (
    <section>
      {index !== 0 && <div className="delete-section" style={{marginTop:"70px"}}></div>}
      <div className="form-group">
        <div className="label-wrapper">
          <label htmlFor="course">{t("Course")}</label>
        </div>
        <AutoComplete
          data={autoCompleteCourseData}
          onChange={(event, componentEvent) => {
            onChangeAutoCompleteCourse(componentEvent, index);
          }}
          onSelection={(courseId) => onSelectedCourse(courseId, index)}
          value={
            candidateCourse.otherCourse ||
            candidateCourse.courseDescription ||
            ""
          }
          placeholder={t("Title of qualification awarded")}
          maxLength={250}
        />
      </div>
      <div className="form-group">
        <div className="label-wrapper">
          <label htmlFor="institution">{t("Institution")}</label>
        </div>
        <AutoComplete
          data={autoCompleteSchoolData}
          onChange={(event, componentEvent) => {
            onChangeAutoCompleteSchool(componentEvent, index);
          }}
          onSelection={(schoolId) => onSelectedSchool(schoolId, index)}
          value={
            candidateCourse.otherSchool ||
            candidateCourse.schoolDescription ||
            ""
          }
          placeholder={t("Title of qualification awarded")}
          maxLength={250}
        />
      </div>
      <div className="training-date">
        <div className="form-group">
          <div className="label-wrapper">
            <label htmlFor="startDate">
              {t("Start Year")}
              {isStartDateValid === false && (
                <span className="error-msg">{t("Start Year is invalid.")}</span>
              )}
            </label>
          </div>
          <input
            type="number"
            placeholder="yyyy"
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 4);
            }}
            name="startDate"
            onChange={onChangeStartDate}
            value={candidateCourse.startDate}
          />
        </div>
        <div className="form-group">
          <div className="label-wrapper">
            <label htmlFor="endDate">
              {t("End Year")}
              {isEndDateValid === false && (
                <span className="error-msg">{t("End Year is invalid.")}</span>
              )}
            </label>
          </div>
          <input
            type="number"
            placeholder="yyyy"
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 4);
            }}
            name="endDate"
            onChange={onChangeEndDate}
            value={candidateCourse.endDate}
          />
        </div>
        <div className="ongoing">
          <div className="label-wrapper">
            <label htmlFor="onGoing">{t("Ongoing")}</label>
          </div>
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              id="onGoing"
              name="onGoing"
              defaultChecked={candidateCourse.isOngoing}
              onChange={(event) => onChangeIsOngoing(event, index)}
              disabled={
                candidateCourse.endDate < today.getFullYear() &&
                candidateCourse.endDate !== null
              }
            />
          </div>
        </div>
        <div className="isCertification">
          <div className="label-wrapper">
            <label htmlFor="isCertification">{t("Is Certification")}?</label>
          </div>
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              id="isCertification"
              name="isCertification"
              defaultChecked={candidateCourse.isCertification}
              onChange={(event) => onChangeIsCertification(event, index)}
            />
          </div>
        </div>
        <div className="form-group">
          <div className="label-wrapper">
            <label htmlFor="finalClassification">
              {t("Final Classification")}
            </label>
          </div>
          <input
            className="custom-input"
            type="number"
            id="finalClassification"
            name="finalClassification"
            value={candidateCourse.finalClassification}
            onChange={(event) => onChangeFinalClassification(event, index)}
            placeholder={t("Classification grade...")}
            min="0"
            max="1000"
          />
        </div>
      </div>
      {index !== 0 && (
        <button
          type="button"
          id="deleteEducationSection"
          onClick={() => onDelete(index)}
          className="app-button btn-second btn-md"
          style={{float:"right"}}
        >
          <img src={icon_delete} alt="delete" width="12px" height="auto" />{" "}
          {t("Delete")}
        </button>
      )}
    </section>
  );
};

export default EducationForm;

EducationForm.propTypes = {
  candidateCourse: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChangeCourse: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSelectedCourse: PropTypes.func.isRequired,
  onSelectedSchool: PropTypes.func.isRequired,
  onChangeIsOngoing: PropTypes.func.isRequired,
  onChangeFinalClassification: PropTypes.func.isRequired
};
